import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { StudentAssignment } from '@ts-core/modules/assignments/types';
import {
  getStudentAssignmentsQuery,
  GetStudentAssignmentsQueryResult,
  GetStudentAssignmentsQueryVariables,
} from '../graphql/queries/getStudentAssignmentsQuery';

type StudentAssignmentsHookResult = DataFetcherHookResult<StudentAssignment[], 'studentAssignments'>;

interface StudentAssignmentsHookInput {
  courseId: string;
  studentId: string;
}

export default function useStudentAssignments(input: StudentAssignmentsHookInput): StudentAssignmentsHookResult {
  const { courseId, studentId } = input;
  const { data, loading, error } = useQuery<GetStudentAssignmentsQueryResult, GetStudentAssignmentsQueryVariables>(getStudentAssignmentsQuery, {
    variables: { courseId, studentId },
  });

  return { loading, error: getErrorMessage({ error }), studentAssignments: data?.studentAssignments };
}
